import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators, FormControl, FormGroup } from '@angular/forms';

import { NewmemberService } from '../../services/newmember.service';
import { StoreService } from '../../services/store.service';
import { SourceService } from '../../services/source.service';
import { MatStepper } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogService } from 'primeng/api';
import { AddonmemberComponent } from '../addonmember/addonmember.component';
import { DuplicateLicenseComponent } from '../duplicate-license/duplicate-license.component';
import { TermConditionComponent } from '../term-condition/term-condition.component';

import { MemberPrintComponent } from '../member-print/member-print.component';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { DocuploadComponent } from '../docupload/docupload.component';
import { UserService } from '../../services/user.service';
// import { OtpComponent } fr om '../otp/otp.component';
import { MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { MultipleaddressComponent } from '../multipleaddress/multipleaddress.component';
import { DigitalDeclarationComponent } from '../digitaldeclaration/digitaldeclaration.component';

@Component({
  selector: 'app-addmember',
  templateUrl: './addmember.component.html',
  styleUrls: ['./addmember.component.css'],
  providers: [DialogService]
})



export class AddmemberComponent implements OnInit {

  @ViewChild("supportDocuments") private supportDocuments: DocuploadComponent;

  nameblock: RegExp = /^[^<>*!@#\s$_%+=~`^{};:.,&|?\[\]'"]+$/;
  completeAplhaNumeric: RegExp = /^[^<>*!@#$_%+=~`^{}()\\\/;:.,&|?\[\]'"]+$/;
  blockSpecial: RegExp = /^[^0-9<>*!@#$_%+=~`^{}()-/\\;:.,&|?\[\]'"]*$/;
  onlyNum: RegExp = /^[0-9]*$/;
  //pincode: RegExp = /[^(a-z)]{6}$/;
  // ([0-9]{6}|[0-9]{3}\s[0-9]{3}) ;
  pinCode: RegExp = /^[0-9]{6}$/;
  alphaNumberic: RegExp = /[a-z0-9]/i;
  biForm: FormGroup;
  bi: any = {};
  BIverified: boolean;
  BDverified: boolean;
  recordList: Object[] = [];
  selectedMid: any = {};
  biFormValid: boolean = true;
  BIverifiedNo: any;
  PMverifiedNo: any;
  inProgress: boolean = false;
  adonSpinner: boolean = false;
  hardStop: boolean = false;
  validateFailed: boolean = false;
  storeList: any;
  sourceList:any;
  declDocumentType: string;
  declFileName: string;
  isDeclToUploaded: boolean = false;
  bdForm: FormGroup;
  bdFormValid: boolean = true;

  babForm: FormGroup;
  babFormValid: boolean = true;


  bamForm: FormGroup;
  bamFormValid: boolean = true;
  termAddonVerified: boolean = false;
  declareAddonVerified: boolean = false;

  pmForm: FormGroup;
  pmFormValid: boolean = true;

  attested: boolean;

  PMverified: boolean;
  myform: FormGroup;
  mid: number;
  mstatus: string;
  mlid: string;

  marketCommunication: boolean = true;

  selectDate: Date;
  otpShowHide: boolean = false;
  showOrHide: boolean = false;
  showOrHideBI: boolean = false;
  otpShowHideBI: boolean = false;

  model: any = {};
  membername: string;
  index: number = 0;
  BDflag: boolean = true;
  draftFlag: boolean = false;
  agelimit: any;
  yearlimit: any;
  currentDate: any;
  yearRange: any;

  licenceType: Object[] = [];
  docType: Object[] = [];
  licenceList = [];
  selectedLicence = [];
  uploadedFiles: any = {};
  addonList: any = [];
  populateForm: any = {};
  bd: any = {};
  ba: any = {};
  pm: any = {};
  termVeified: boolean = false;
  declareVerified: boolean =false;
  today: any;
  eMaxLimit: any;
  adProgressBar: boolean = false;
  sbSpinner: boolean = false;
  regex: string;
  proof = [];
  cardCreateStatus: any;
  pidExpiryDisable: boolean = false;
  baStateList: any = [];
  baCityList: any = [];
  baCountyList: any = [];
  baStateDropDisable: boolean = true;
  baCityDropDisable: boolean = true;
  maStateList: any = [];
  maCityList: any = [];
  maCountyList: any = [];
  maStateDropDisable: boolean = true;
  maCityDropDisable: boolean = true;
  pmStateList: any = [];
  pmCityList: any = [];
  pmCountyList: any = [];
  pmStateDropDisable: boolean = true;
  pmCityDropDisable: boolean = true;
  display: boolean = false;
  display2: boolean = false;
  selectedStore: any = {};
  // selectedSource:any = {};
  hardStopLicenseType = [];
  declarationDocumentId: number = null;
  declarationPages: number = 0;
  basicOTPId: number;  
  smallOfficeOptions: any = [];
  smallOfficeType: string;
  isSmallOffice: boolean = false;
  licenseVerify = [];
  thirdPartyCheck: string = "";

  constructor(private datePipe: DatePipe, private us:UserService,
     public store: StoreService,
     public source:SourceService,
     public nms: NewmemberService, 
     public sanitizer: DomSanitizer, 
     public dialogService: DialogService,
     public router: Router, 
     private messageService: MessageService, 
     private confirmationService: ConfirmationService,
      public activatedRoute: ActivatedRoute) { }



  onSubmit() {
    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.myform.value));
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  // get f() { return this.userform.controls; }
  ngOnInit() {
    this.nms.setDefault(null, null, null);
    this.us.getUserContent().subscribe((res: any) => {
      
      if(res.code == "SUCCESS") {
        localStorage.setItem("token", res.response);
        localStorage.setItem("currDate", res.responseDateTime);
        // this.source.getAllSources().subscribe((res: any) => {
        //   if (res.code == "SUCCESS") {
        //  this.sourceList =  res.response;
        //  console.log(this.sourceList);
        // //  this.biForm.controls['maSource'].setValue(1);
        // //  this.bi.maSourceId = 1;
        // }
        // });
        this.store.getMappedStores(1).subscribe((res: any) => {
          if (res.code == "SUCCESS") {
         this.storeList =  res.response; 
        }
        });
      }
    });
    this.BIverified = false;
    this.BDverified= false;
    this.bd.businessLicenseParamsList = [];
    this.bd.taxExemption = false;
    this.bd.ownerNameNotVisible = false;
    this.ba.sameAsBusinessAddress = false;
    this.pm.isBusinessOwner = false;
    this.pm.cardHolderDocuments = [];
    this.attested = true;

    if (localStorage.getItem("storeId") && localStorage.getItem("storeId") != "") {
      this.bi.storeId = parseInt(localStorage.getItem("storeId"));
    }
    // if (localStorage.getItem("maSourceId") && localStorage.getItem("maSourceId") != "") {
    //   this.bi.maSourceId = parseInt(localStorage.getItem("maSourceId"));
    // }
    this.bi.marketCommunication = true;

    this.biForm = new FormGroup({
      firstName: new FormControl('', Validators.compose([
        Validators.required
      ])),
      middleName: new FormControl(),
      lastName: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mobileno: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[5-9][0-9]{9}$')
      ])),
      store: new FormControl('', Validators.compose([
        Validators.required
      ])),
      // maSource: new FormControl('', Validators.compose([
      //   Validators.required
      // ])),
      mselected: new FormControl(),
      attestation: new FormControl(),
      marketCommunication: new FormControl(),
      emailId: new FormControl('', Validators.compose([
        Validators.pattern('^[A-Za-z0-9._-]+[@][A-Za-z0-9._-]+[.][a-zA-Z]{2,5}$')
      ]))
    });
  
    this.bdForm = new FormGroup({
      businesstype: new FormControl('', Validators.compose([
        Validators.required
      ])),
      businessName: new FormControl('', Validators.compose([
        Validators.required
      ])),      
      smallOfficeType: new FormControl(),
      businessnature: new FormControl('', Validators.compose([
        Validators.required
      ])),
      Lic_0: new FormControl(),
      Lic_1: new FormControl(),
      Lic_2: new FormControl(),
      expiry_0: new FormControl(),
      expiry_1: new FormControl(),
      expiry_2: new FormControl(),
      state_0: new FormControl(),
      state_1: new FormControl(),
      state_2: new FormControl(),
      MultiSelect: new FormControl('', Validators.compose([
        Validators.required
      ])),
      isBusinessOwnerNameGiven: new FormControl(false),
      isTaxExemption: new FormControl(false),
      declareattestation: new FormControl()
    });
    this.babForm = new FormGroup({
      buildingno: new FormControl('', Validators.compose([
        Validators.required
      ])),
      streetname: new FormControl('', Validators.compose([
        Validators.required
      ])),
      city: new FormControl('', Validators.compose([
        Validators.required
      ])),
      state: new FormControl('', Validators.compose([
        Validators.required
      ])),
      pinno: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{6}$')
      ])),
      county: new FormControl('', Validators.compose([
        Validators.required
      ]))
    });
    this.bamForm = new FormGroup({
      county: new FormControl('', Validators.compose([
      ])),
      mbuildingno: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mstreetname: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mcity: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mstate: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mpinno: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{6}$')
      ])),
      mailsameasbusiness: new FormControl(false)
    });
    this.pmForm = new FormGroup({
      firstName: new FormControl('', Validators.compose([
        Validators.required
      ])),
      middleName: new FormControl(),
      lastName: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mobile: new FormControl( {disabled: true}),
      dob: new FormControl('', Validators.compose([
        Validators.required
      ])),
      buildingno: new FormControl('', Validators.compose([
        Validators.required
      ])),
      streetname: new FormControl('', Validators.compose([
        Validators.required
      ])),
      city: new FormControl('', Validators.compose([
        Validators.required
      ])),
      county: new FormControl('', Validators.compose([
        Validators.required
      ])),
      state: new FormControl('', Validators.compose([
        Validators.required
      ])),
      pinno: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{6}$')
      ])),
      docType: new FormControl('', Validators.compose([
        Validators.required
      ])),
      cardLic: new FormControl('', Validators.compose([
        Validators.required
      ])),
      cardExpiry: new FormControl('', Validators.compose([
        Validators.required
      ])),
      cardState: new FormControl('', Validators.compose([
        Validators.required
      ])),
      STDLandLine: new FormControl(),
      whatsappNumber: new FormControl({ disabled: true }),
      mailId: new FormControl('', Validators.compose([
        Validators.pattern('^[A-Za-z0-9._-]+[@][A-Za-z0-9._-]+[.][a-zA-Z]{2,5}$')
      ])),
      education: new FormControl({ disabled: true }),
      income: new FormControl({ disabled: true }),
      social: new FormControl({ disabled: true }),
      isBusinessOwner: new FormControl(false),
      attestation: new FormControl({ value: false, disabled: true }),
    });
    var date = new Date();
    date.setFullYear(date.getFullYear() - 18);
    this.agelimit = date;
    this.currentDate = new Date();
    //this.currentDate.setDate( this.currentDate.setDate() + 1 );

    let temp = new Date();
    this.eMaxLimit = new Date(temp.setFullYear(temp.getFullYear() + 99));
    this.yearlimit = (this.agelimit.getFullYear() - 82) + ":" + this.agelimit.getFullYear();
    this.yearRange = this.currentDate.getFullYear() + ":" + this.eMaxLimit.getFullYear();
    if (this.activatedRoute.snapshot.params.memberId) {
      let data: any = {};
      data.maMembershipId = this.activatedRoute.snapshot.params.memberId;
      data.status = "DRAFT";
      this.termAddonVerified = true;
      this.termVeified = true;
      this.BIverified = true;
      this.selectedMid = data;
      this.resumeDraft(data);
    }
    this.cardCreateStatus = [{ label: 'Active', value: 'A' }, { label: 'Draft', value: 'DRAFT' }];

  }

  storeSelection() {
    var store = this.storeList.filter(proj => proj.storeId === this.bi.storeId);
    if (store != null && store[0] != null) {
      this.selectedStore = store[0];
    }
  }
  

  ngDoCheck() {
    if (!this.draftFlag) {
      if (this.BIverified) {
        this.adProgressBar = true; // show progress bar
        this.nms.getExsisting(this.bi.phoneNbr).subscribe((res: any) => {
          if (res.code == "SUCCESS") {
            this.recordList = res.response;
            this.draftFlag = true;
            this.adProgressBar = false; // hide progress bar
          } else {
            this.adProgressBar = false; // hide progress bar
            this.draftFlag = true;
          }
        }, err => {
          console.error('ERROR', err);
          this.draftFlag = true;
          this.adProgressBar = false; // hide progress bar
        });
        this.draftFlag = true;
      }
    }
  }
  onTabOpen(event) {
    this.index = event.index;
    if (this.index == 0) {
      this.BDflag = true
    }
  }

  btypeChange() {
    this.bd.sicCode = "";
    this.ddCheck();
  }

  
  smallOfficeDropChange() {
    var smallOffice = this.smallOfficeOptions.filter(proj => proj.licenseType === this.smallOfficeType);

    if (smallOffice.length > 0) {
      this.declDocumentType = smallOffice[0].documentName;
      this.nms.declDocumentType = this.declDocumentType;
      this.declFileName = smallOffice[0].licFileName;
      this.isDeclToUploaded = true;

      if (this.bd && this.bd.supportingDocuments && this.bd.supportingDocuments.length > 0) {
        this.declarationChanged(this.bd.supportingDocuments[0].documentType);
      }
      
    }
  }

  ddCheck() {
    var isDeclarationChanged = false;
    var existingDocumentType = null;
    this.smallOfficeOptions = [];
    this.smallOfficeType = null;
    var smallOfficeOption: any = {};

    this.isSmallOffice = this.bd.segmentCode === 'O&I-BUSINESS SERVICES' ? true : false;

    if (this.bd && this.bd.supportingDocuments && this.bd.supportingDocuments.length > 0) {
      existingDocumentType = this.bd.supportingDocuments[0].documentType;
    }

    var declarationDoc = this.populateForm.DeclarationDocuments;
    this.isDeclToUploaded = false;
    for (var docIndex in declarationDoc) {
      if (declarationDoc[docIndex].segmentCode == this.bd.segmentCode) {
        if (declarationDoc[docIndex].fileName != null) {
          this.declDocumentType = declarationDoc[docIndex].documentName;
          this.declFileName = declarationDoc[docIndex].fileName;
          this.isDeclToUploaded = true;

        } else if (declarationDoc[docIndex].licenseDeclarations != null) {
          var licenseDeclarations = declarationDoc[docIndex].licenseDeclarations;
          
          for (var declIndex in licenseDeclarations) {
              var license = this.populateForm.businessLicense.filter(proj => proj.code === licenseDeclarations[declIndex].licenseType);
              
              if (license.length == 0) {
                this.smallOfficeOptions.push(licenseDeclarations[declIndex]);
              }
          }
          this.smallOfficeOptions.sort((a,b) => a.licenseType.localeCompare(b.licenseType));
        }
        break;
      }
    }
    this.declarationChanged(existingDocumentType);
  }

  declarationChanged(existingDocumentType) {
    var isDeclarationChanged = false;
    if (existingDocumentType != this.declDocumentType) {
      isDeclarationChanged = true;
      this.nms.declDocumentType = this.declDocumentType;
    }
    if (isDeclarationChanged) {
      this.bd.supportingDocuments = [];
      this.uploadedFiles.supportingDocuments = null;
      if (this.supportDocuments != null) {
        this.supportDocuments.reset();
      }

    }
  }

  resetOTP(type) {
    if (type == 'bi') {
      this.BIverified = false;
      this.draftFlag = false;
      this.PMverified = false;
    } else {
      this.PMverified = false;
    }
    if (type == "bi") {
      if (this.BIverifiedNo == this.bi.phoneNbr) {
        this.BIverified = true;
        this.PMverified = true;
      }
    } else {
      if (this.PMverifiedNo == this.pm.phoneNbr) {
        this.PMverified = true;
      }
    }
  }

  saveBDInfo(stepper: MatStepper) {
    this.BDflag = false;
    this.index = 1;
    if (this.ba.businessCityName != null) {
      this.changeCity('business', this.ba.businessCityName);
    }
    if (this.ba.mailingCityName != null) {
      this.changeCity('mailing', this.ba.mailingCityName);
    }
  }

  saveExsistInfo(stepper: MatStepper) {
    let firstformvalid = this.biForm.valid;
    this.adProgressBar = true; // show spineer
    if (this.biForm.valid) {
      this.nms.saveInfo(this.bi).subscribe((res: any) => {
        if (res.code == "SUCCESS") {
          this.pm.firstName = this.bi.firstName;
          this.pm.middleName = this.bi.middleName;
          this.pm.lastName = this.bi.lastName;
          this.pm.phoneNbr = this.bi.phoneNbr;
          this.pm.landlineNbr = this.bi.phoneNbr;
          this.pm.email = this.bi.email;
          this.adProgressBar = false; // hide spineer
          stepper.selected.completed = true;
          if (stepper.selectedIndex == 0)
            stepper.next();
        }
      }, err => {
        this.adProgressBar = false; // hide spineer
        console.error('ERROR', err);
      });
    } else {
      this.biFormValid = false;
      this.adProgressBar = false;
    }
  }

  mockLicenseType() {
    // Temp method
    var licenseType = this.populateForm.businessLicense.filter(proj => proj.code === "SCER");
    if (licenseType[0] != null) {
      licenseType[0].text = "SHOP AND COMMERCIAL ESTABLISHMENT REGISTRATION";
    }
  }
  saveInfo(stepper: MatStepper) {
    let firstformvalid = this.biForm.valid;
    if (this.biForm.valid) {
      this.adProgressBar = true; // show spinner
      this.bi.otpId = this.basicOTPId;
      if (this.nms.mlid != null) {
        this.nms.saveInfo(this.bi).subscribe((res: any) => {
          if (res.code == "SUCCESS") {
            this.parseSaveInfoResponse(res, stepper);
          }
        }, err => {
          this.adProgressBar = false; // hide spinner
          console.error('ERROR', err);
        });

      } else {     
        this.nms.saveInfoWithOTP(this.bi).subscribe((res: any) => {
          if (res.code == "SUCCESS") {
            localStorage.setItem('userToken', res.response.key);
            this.parseSaveInfoResponse(res, stepper);
          }
        }, err => {
          this.adProgressBar = false; // hide spinner
          console.error('ERROR', err);
        });
      }
    } else {
      this.biFormValid = false;
    }
  }

  private parseSaveInfoResponse(res: any, stepper: MatStepper) {
    this.nms.setDefault(res.response.membershipNbr, res.response.maMembershipId, res.response.status);
    this.pm.firstName = this.bi.firstName;
    this.pm.middleName = this.bi.middleName;
    this.pm.lastName = this.bi.lastName;
    this.pm.phoneNbr = this.bi.phoneNbr;
    this.pm.landlineNbr = this.bi.phoneNbr;
    this.pm.email = this.bi.email;
    this.PMverified = true;
    this.PMverifiedNo = this.pm.phoneNbr;
    this.adProgressBar = false; // hide spinner
    this.nms.formFill().subscribe((res: any) => {
      if (res.code == "SUCCESS") {
        this.populateForm = res.response;
        this.mockLicenseType();
        this.today = res.responseDateTime;
        stepper.selected.completed = true;
        if (stepper.selectedIndex == 0)
          stepper.next();
      }
    }, err => {
      console.error('ERROR', err);
    });
  }

  resumeDraft(mdetail) {
    this.nms.formFill().subscribe((res: any) => {
      if (res.code == "SUCCESS") {
        this.populateForm = res.response;
        this.mockLicenseType();
        this.today = res.responseDateTime;
        this.nms.setDefault(mdetail.membershipNbr, mdetail.maMembershipId, mdetail.status);
        this.nms.populateForm().subscribe((res: any) => {
          if (res.code == "SUCCESS" && res.response != null) {
            this.adProgressBar = false; // hide progress bar
            this.bi.firstName = res.response.firstName;
            this.bi.middleName = res.response.middleName;
            this.bi.lastName = res.response.lastName;
            this.bi.extensionNbr = res.response.extensionNbr;
            this.bi.phoneNbr = res.response.phoneNbr;
            this.bi.storeId = res.response.storeId;
            this.bd.businessName = res.response.businessName;
            this.bd.segmentCode = res.response.segmentCode;
            this.bd.sicCode = res.response.sicCode;
            this.bd.taxExemption = res.response.taxExemption ? res.response.taxExemption : false;
            this.bd.ownerNameNotVisible = res.response.ownerNameNotVisible ? res.response.ownerNameNotVisible : false;
            this.bd.supportingDocuments = [];
            if (res.response.supportingDocuments != null) {
              this.bd.supportingDocuments = res.response.supportingDocuments;
              if (this.bd.supportingDocuments.length > 0) {
                this.declDocumentType = this.bd.supportingDocuments[0].documentType;
                this.nms.declDocumentType = this.declDocumentType;
                this.isDeclToUploaded = true;
                this.uploadedFiles.supportingDocuments = [];
                let temp: any = this.bd.supportingDocuments[0];
                temp.ustatus = this.bd.supportingDocuments[0].documentId != null ? true : false;
                this.uploadedFiles.supportingDocuments[0] = temp;
                }
              }

            if (res.response.memberBusinessLicense) {
              this.bd.businessLicenseParamsList = res.response.memberBusinessLicense;
              this.selectedLicence = [];
              this.uploadedFiles.businessLicenseParamsList = [];
              for (let list of this.bd.businessLicenseParamsList) {
                this.selectedLicence.push(list.licenseType);
                let temp: any = list;
                temp.documentType = list.licenseType;
                temp.ustatus = list.documentId != null ? true : false;
                this.uploadedFiles.businessLicenseParamsList.push(temp);
                for (let list1 of this.populateForm.businessLicense) {
                  if (list1.code == list.licenseType) {
                    list.name = list1.text;
                    list.defaultExpiryYear = list1.defaultExpiryYear;
                    list.maxLength = list1.maxLength;
                  }
                }
              }
              for (var i = 0; i < this.bd.businessLicenseParamsList.length; i++) {
                if(this.bd.businessLicenseParamsList[i].maxLength > 0) {
                  this.bdForm.get('Lic_' + i).setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+this.bd.businessLicenseParamsList[i].maxLength+'}$')]);
                  this.bdForm.get('Lic_' + i).updateValueAndValidity();
                } else {
                  this.bdForm.get('Lic_' + i).setValidators([Validators.required]);
                  this.bdForm.get('Lic_' + i).updateValueAndValidity();
                }
              }
            }
            if (res.response.authorizationDocument && res.response.authorizationDocument.documentId) {
              this.bd.authorizationDocument = res.response.authorizationDocument;
              this.uploadedFiles.authorizationDocument = [];
              let temp: any = this.bd.authorizationDocument;
              temp.ustatus = this.bd.authorizationDocument != null ? true : false;
              
              this.uploadedFiles.authorizationDocument[0] = temp;
            }
            this.ba = res.response.memberAddresses != null ? res.response.memberAddresses : {};

            this.baStateList = [];
            this.baStateList.push(this.ba.businessStateProvCode);

            this.baCityList = [];
            this.baCityList.push(this.ba.businessCityName);

            this.maStateList = [];
            this.maStateList.push(this.ba.mailingStateProvCode);

            this.maCityList = [];
            this.maCityList.push(this.ba.mailingCityName);

            if (res.response.cardHolderInfo != null) {
              for (let mem of res.response.cardHolderInfo) {
                if (mem.cardHolderType === "P") {
                  this.pm = mem;
                  this.pm.phoneNbr = this.bi.phoneNbr;
                  this.pm.landlineNbr = this.bi.phoneNbr;
                  this.PMverified = true;
                  this.PMverifiedNo = this.pm.phoneNbr;
                  this.uploadedFiles.cardHolderDocuments = [];
                  for (let list of mem.cardHolderDocuments) {
                    
                    list.ustatus = list.documentId != null ? true : false;
                    this.uploadedFiles.cardHolderDocuments.push(list);
                  }
                  for (let list of this.populateForm.photoIdTypes) {
                    if (list.code == this.pm.photoTypeCode) {
                      if (list.defaultExpiryYear > 0) {
                        this.pidExpiryDisable = true;
                        if (this.pm.expirationDt == null) {
                          let currDate = new Date(localStorage.getItem('currDate'));
                          this.pm.expirationDt = new Date(currDate.setFullYear(currDate.getFullYear() + list.defaultExpiryYear));
                        }
                      } else {
                        this.pidExpiryDisable = false;
                      }
                      if(list.maxLength > 0) {
                        this.pmForm.get('cardLic').setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+list.maxLength+'}$')]);
                        this.pmForm.get('cardLic').updateValueAndValidity();
                      } else {
                        this.pmForm.get('cardLic').setValidators([Validators.required]);
                        this.pmForm.get('cardLic').updateValueAndValidity();
                      }
                      break;
                    }
                  }
                } else {
                  this.addonList.push(mem);
                }
              }
            }
            if (res.response.cardHolderInfo == null || res.response.cardHolderInfo.length == 0) {
              this.pm.firstName = this.bi.firstName;
              this.pm.middleName = this.bi.middleName;
              this.pm.lastName = this.bi.lastName;
              this.pm.phoneNbr = this.bi.phoneNbr;
              this.pm.landlineNbr = this.bi.phoneNbr;
              this.PMverified = true;
            }
            this.ddCheck();
            this.smallOfficeType = this.declDocumentType;
            this.smallOfficeDropChange();
          } else {
            this.router.navigateByUrl("/");
          }
        }, err => {
          this.adProgressBar = false; // hide progress bar
          console.error('ERROR', err);
        });
      }
    }, err => {
      console.error('ERROR', err);
    });
  }

  continueExsisting(mdetail) {
    if (mdetail.status != "DRAFT") {
      this.confirmationService.confirm({
        message: 'Are you sure you want to view member, unsaved form data will be lost?',
        acceptLabel: 'Yes',
        rejectLabel: 'No',
        accept: () => {
          if (mdetail.status == "QC PENDING") {
            this.router.navigateByUrl("/qc-status/qualitycontrol/" + mdetail.maMembershipId);
          } else {
            this.router.navigateByUrl("/viewmember/" + mdetail.membershipNbr);
          }
        },
        reject: () => {
          this.selectedMid = {};
        }
      });
    } else {
      this.confirmationService.confirm({
        message: 'Are you sure you want to overwrite form fields with exsisting draft data?',
        acceptLabel: 'Yes',
        rejectLabel: 'No',
        accept: () => {
          this.nms.formFill().subscribe((res: any) => {
            if (res.code == "SUCCESS") {
              this.populateForm = res.response;
              this.mockLicenseType();
              this.today = res.responseDateTime;
              this.nms.setDefault(mdetail.membershipNbr, mdetail.maMembershipId, mdetail.status);
              this.nms.populateForm().subscribe((res: any) => {
                if (res.code == "SUCCESS") {
                  this.bi.firstName = res.response.firstName;
                  this.bi.middleName = res.response.middleName;
                  this.bi.lastName = res.response.lastName;
                  this.bi.phoneNbr = res.response.phoneNbr;
                  this.bi.storeId = res.response.storeId;
                  this.bd.businessName = res.response.businessName;
                  this.bd.segmentCode = res.response.segmentCode;
                  this.bd.sicCode = res.response.sicCode;
                  this.bd.taxExemption = res.response.taxExemption ? res.response.taxExemption : false;
                  this.bd.ownerNameNotVisible = res.response.ownerNameNotVisible ? res.response.ownerNameNotVisible : false;
                  if (res.response.memberBusinessLicense) {
                    this.bd.businessLicenseParamsList = res.response.memberBusinessLicense;
                    this.selectedLicence = [];
                    this.uploadedFiles.businessLicenseParamsList = [];
                    for (let list of this.bd.businessLicenseParamsList) {
                      this.selectedLicence.push(list.licenseType);
                      let temp: any = list;
                      temp.documentType = list.licenseType;
                      temp.ustatus = list.documentId != null ? true : false;
                      this.uploadedFiles.businessLicenseParamsList.push(temp);
                      for (let list1 of this.populateForm.businessLicense) {
                        if (list1.code == list.licenseType) {
                          list.name = list1.text;
                          list.defaultExpiryYear = list1.defaultExpiryYear;
                          list.maxLength = list1.maxLength;
                        }
                      }
                    }
                    for (var i = 0; i < this.bd.businessLicenseParamsList.length; i++) {
                      if(this.bd.businessLicenseParamsList[i].maxLength > 0) {
                        this.bdForm.get('Lic_' + i).setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+this.bd.businessLicenseParamsList[i].maxLength+'}$')]);
                        this.bdForm.get('Lic_' + i).updateValueAndValidity();
                      } else {
                        this.bdForm.get('Lic_' + i).setValidators([Validators.required]);
                        this.bdForm.get('Lic_' + i).updateValueAndValidity();
                      }
                    }
                  }
                  if (res.response.authorizationDocument && res.response.authorizationDocument.documentId) {
                    this.bd.authorizationDocument = res.response.authorizationDocument;
                    this.uploadedFiles.authorizationDocument = [];
                    let temp: any = this.bd.authorizationDocument;
                    temp.ustatus = this.bd.authorizationDocument.documentId != null ? true : false;
                    this.uploadedFiles.authorizationDocument[0] = temp;
                  }
                  this.bd.supportingDocuments = [];
                  if (res.response.supportingDocuments != null) {
                    this.bd.supportingDocuments = res.response.supportingDocuments;
                    if (this.bd.supportingDocuments.length > 0) {
                      this.declDocumentType = this.bd.supportingDocuments[0].documentType;
                      this.isDeclToUploaded = true;
                      this.uploadedFiles.supportingDocuments = [];
                      let temp: any = this.bd.supportingDocuments[0];
                      temp.ustatus = this.bd.supportingDocuments[0].documentId != null ? true : false;
                      this.uploadedFiles.supportingDocuments[0] = temp;
                    }
                  }
                  this.ba = res.response.memberAddresses != null ? res.response.memberAddresses : {};
                        
                  this.baStateList = [];
                  this.baStateList.push(this.ba.businessStateProvCode);

                  this.baCityList = [];
                  this.baCityList.push(this.ba.businessCityName);

                  this.maStateList = [];
                  this.maStateList.push(this.ba.mailingStateProvCode);

                  this.maCityList = [];
                  this.maCityList.push(this.ba.mailingCityName);
                  if (res.response.cardHolderInfo != null) {
                    for (let mem of res.response.cardHolderInfo) {
                      if (mem.cardHolderType == "P") {
                        this.pm = mem;
                        this.pm.phoneNbr = this.bi.phoneNbr;
                        this.pm.landlineNbr = this.bi.phoneNbr;
                        this.PMverifiedNo = this.pm.phoneNbr;
                        this.PMverified = true;
                        this.uploadedFiles.cardHolderDocuments = [];
                        for (let list of mem.cardHolderDocuments) {
                          list.ustatus = list.documentId != null ? true : false;
                          this.uploadedFiles.cardHolderDocuments.push(list);
                        }
                        for (let list of this.populateForm.photoIdTypes) {
                          if (list.code == this.pm.photoTypeCode) {
                            if (list.defaultExpiryYear > 0) {
                              this.pidExpiryDisable = true;
                              if (this.pm.expirationDt == null) {
                                let currDate = new Date(localStorage.getItem('currDate'));
                                this.pm.expirationDt = new Date(currDate.setFullYear(currDate.getFullYear() + list.defaultExpiryYear));
                              }
                            } else {
                              this.pidExpiryDisable = false;
                            }
                            if(list.maxLength > 0) {
                              this.pmForm.get('cardLic').setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+list.maxLength+'}$')]);
                            } else {
                              this.pmForm.get('cardLic').setValidators([Validators.required]);
                            }
                            this.pmForm.get('cardLic').updateValueAndValidity();
                            break;
                          }
                        }
                      } else {
                        this.addonList.push(mem);
                      }
                    }
                  }
                  if (res.response.cardHolderInfo == null || res.response.cardHolderInfo.length == 0) {
                    this.pm.firstName = this.bi.firstName;
                    this.pm.middleName = this.bi.middleName;
                    this.pm.lastName = this.bi.lastName;
                    this.pm.phoneNbr = this.bi.phoneNbr;
                    this.pm.landlineNbr = this.bi.phoneNbr;
                  }
                  this.ddCheck();
                }
              }, err => {
                console.error('ERROR', err);
              });
            }
          }, err => {
            console.error('ERROR', err);
          });
        },
        reject: () => {
          this.selectedMid = {};
        }
      });
    }
  }

  help() {
    this.display = true;
  }
  help2() {
    this.display2 = true;
  }

  ustatusUpdate(event, group, type) {
    if (!this.uploadedFiles[group]) {
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({ "ustatus": event, "documentType": type });
    } else {
      let check = 0;
      for (let list of this.uploadedFiles[group]) {
        if (list.documentType == type) {
          check = 1;
          list.ustatus = event;
        }
      }
      if (check == 0) {
        this.uploadedFiles[group].push({ "ustatus": event, "documentType": type });
      }
    }
  }

  updateUploadstatus(event, group, type) {
    if (!this.uploadedFiles[group]) {
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({ "documentId": event.documentId, "documentType": type });
    } else {
      let done = 0;
      for (let list of this.uploadedFiles[group]) {
        if (list.documentType == type) {
          list.documentId = event.documentId;
          done = 1;
        }
      }
      if (done == 0) {
        this.uploadedFiles[group].push({ "documentId": event.documentId, "documentType": type });
      }
    }
  }

  updateLicenceList(event) {
    var removeItem = 1;
    for (let val of event.value) {
      if (event.itemValue == val) {
        removeItem = 0;
      }
    }
    if (removeItem == 1) {
      var temp_obj = JSON.parse(JSON.stringify(this.bd.businessLicenseParamsList));
      this.bd.businessLicenseParamsList = [];
      for (var i = 0; i < temp_obj.length; i++) {
        if (temp_obj[i].licenseType == event.itemValue) {     
          if (event.itemValue == "GST") {
            this.hardStopLicenseType["GST REGISTRATION"] = false;
          } else if (event.itemValue == "UAN") {
            this.hardStopLicenseType["UDYOG AADHAAR"] = false;
          }     
          temp_obj.splice(i, 1);
          this.proof[i] = 0;
          break;
        }
        /*if(temp_obj[i].expirationDate && temp_obj[i].expirationDate != '') {
          var date = new Date(temp_obj[i].expirationDate);
          var day = date.getDate();
          var monthIndex = date.getMonth();
          var year = date.getFullYear();
          temp_obj[i].expirationDate = year + '-' + monthIndex + '-' + day;
        }*/
      }
      for (var i = 0; i < temp_obj.length; i++) {
        if(temp_obj[i].expirationDate && temp_obj[i].expirationDate != '') {
          var date = new Date(temp_obj[i].expirationDate);
          var yestDateStr = this.datePipe.transform(date, 'yyyy-MM-dd');
          temp_obj[i].expirationDate = yestDateStr;
        }
      }
      this.bd.businessLicenseParamsList = temp_obj;
       
      this.bdForm.updateValueAndValidity();
      for (var index = 0; index < 3; index++) {
          this.bdForm.get('Lic_' + index).setValidators(null);
          this.bdForm.get('Lic_' + index).updateValueAndValidity();
      }

      for (var i = 0; i < this.bd.businessLicenseParamsList.length; i++) {
        let obj = {}
        obj['Lic_'+i] = this.bd.businessLicenseParamsList[i].licenseNumber?this.bd.businessLicenseParamsList[i].licenseNumber:'';
        obj['expiry_'+i] = this.bd.businessLicenseParamsList[i].expirationDate?this.bd.businessLicenseParamsList[i].expirationDate:'';
        obj['state_'+i] = this.bd.businessLicenseParamsList[i].stateProvCode?this.bd.businessLicenseParamsList[i].stateProvCode:'';        
        this.bdForm.patchValue(obj);
        this.bdForm.updateValueAndValidity();
        if(this.bd.businessLicenseParamsList[i].maxLength > 0) {
          this.bdForm.get('Lic_' + i).setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+this.bd.businessLicenseParamsList[i].maxLength+'}$')]);
          this.bdForm.get('Lic_' + i).updateValueAndValidity();
        } else {
          this.bdForm.get('Lic_' + i).setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]+$')]);
          this.bdForm.get('Lic_' + i).updateValueAndValidity();
        }
      }
      for(var i = 0; i < this.uploadedFiles['businessLicenseParamsList'].length; i++){
        if (this.uploadedFiles['businessLicenseParamsList'][i].documentType == event.itemValue) {          
          this.uploadedFiles['businessLicenseParamsList'].splice(i, 1);
          this.proof[i] = 0;
          break;
        }
      }
    } else {
      for (let list of this.populateForm.businessLicense) {
        if (list.code == event.itemValue) {
          if (list.defaultExpiryYear > 0) {
            this.regex = ''; //^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$ gst validation
            let currDate = new Date(localStorage.getItem('currDate'));
            let expDate = new Date(currDate.setFullYear(currDate.getFullYear() + list.defaultExpiryYear));
            this.bd.businessLicenseParamsList.push({ "name": list.text, "licenseType": list.code, "expirationDate": expDate, "defaultExpiryYear": list.defaultExpiryYear, "maxLength": list.maxLength });
          } else {
            this.regex = '';
            this.bd.businessLicenseParamsList.push({ "name": list.text, "licenseType": list.code, "defaultExpiryYear": list.defaultExpiryYear, "maxLength": list.maxLength });
          }
          if(list.maxLength > 0) {
            this.bdForm.get('Lic_' + (this.bd.businessLicenseParamsList.length - 1)).setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+list.maxLength+'}$')]);
            this.bdForm.get('Lic_' + (this.bd.businessLicenseParamsList.length - 1)).updateValueAndValidity();
          } else {
            this.bdForm.get('Lic_' + (this.bd.businessLicenseParamsList.length - 1)).setValidators([Validators.required]);
            this.bdForm.get('Lic_' + (this.bd.businessLicenseParamsList.length - 1)).updateValueAndValidity();
          }
        }
      }
      if (!this.uploadedFiles['businessLicenseParamsList']) {
        this.uploadedFiles['businessLicenseParamsList'] = [];
        this.uploadedFiles['businessLicenseParamsList'].push({ "ustatus": false, "documentType": event.itemValue });
      } else {
        let check = 0;
        for (let list of this.uploadedFiles['businessLicenseParamsList']) {
          if (list.documentType == event.itemValue) {
            check = 1;
            list.ustatus = false;
          }
        }
        if (check == 0) {
          this.uploadedFiles['businessLicenseParamsList'].push({ "ustatus": false, "documentType": event.itemValue });
        }
      }
    }
  }

  updatePhotoId(event) {
    for (let list of this.populateForm.photoIdTypes) {
      if (list.code == event.value) {
        let currDate = new Date(localStorage.getItem('currDate'));
        this.pm.expirationDt = new Date(currDate.setFullYear(currDate.getFullYear() + list.defaultExpiryYear));
        if (list.defaultExpiryYear > 0) {
          this.pidExpiryDisable = true;
        } else {
          this.pidExpiryDisable = false;
          this.pm.expirationDt = '';
        }
        if(list.maxLength > 0) {
          this.pmForm.get('cardLic').setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+list.maxLength+'}$')]);
          this.pmForm.get('cardLic').updateValueAndValidity();
        } else {
          this.pmForm.get('cardLic').setValidators([Validators.required]);
          this.pmForm.get('cardLic').updateValueAndValidity();
        }
        break;
      }
    }
  }

  populateLicenceDetails(res, index, type) {
    if (res.response.statusCode == "VALID" && res.response.status == "ACTIVE") {
      
      this.bd.businessLicenseParamsList[index].stateProvCode = "";
      for (let l of this.populateForm.StateCityList) {
        if (l.stateName == res.response.state) {
          this.bd.businessLicenseParamsList[index].stateProvCode = l.stateName;
          break;
        }
      }
      this.bd.businessName = res.response.businessName;
      if (res.response.alternateAddresses != null) {
        this.msgToastInfo('Business name and License state are populated using GSP service, Please select address');
        var addressList: any = [];
        var address: any = {};
        var sequence: number = 0;
        address.addressLine1 = res.response.addressLine1;
        address.addressLine2 = res.response.addressLine2;
        address.city = res.response.city;
        address.state = res.response.state;
        address.pincode = res.response.pincode;
        address.type = "Primary";
        address.sequence = 0;
        addressList.push(address);
        for (let addr of res.response.alternateAddresses) {
          sequence++;
          address = {};
          address = addr;
          address.type = "Alternate";
          address.sequence = sequence;
          addressList.push(address);
        }
        this.showMultipleAddress(addressList);
      } else {
        this.msgToastInfo('Business name, License state and business address are populated using GSP service');
        this.ba.businessAddressLine1 = res.response.addressLine1;
        this.ba.businessAddressLine2 = res.response.addressLine2;

        this.ba.businessStateProvCode = res.response.state;
        this.ba.businessCityName = res.response.city;

        this.ba.businessPostalCode = res.response.pincode;
        this.getLocationByPincode(this.ba.businessPostalCode, 'business', true);
      }
      this.hardStopLicenseType[type] = false;
    } else if ((res.response.statusCode == "INVALID"  && type != "UDYOG AADHAAR")  || res.response.status == "PROVISIONAL") {
      this.hardStopLicenseType[type] = true;
      if (res.response.errorMessage != null) {
        this.msgToastInfo(res.response.errorMessage);
      }
      
    }  else if (res.response.status == "CANCELLED") {
      this.hardStopLicenseType[type] = true;
      this.msgToastInfo("Cancelled GST");
      
    }else if (res.response.statusCode == "INVALID"  && type == "UDYOG AADHAAR") {
      this.msgToastInfo("UAN Portal is down, Please manually enter or try later.");
    }
     else {
      this.msgToastInfo("GST Portal is down, Please manually enter or try later.");
      this.hardStopLicenseType[type] = false;
    }
  }

  showMultipleAddress(addressList) {
    let data: any = {};
    data.addressList = addressList;
    const ref = this.dialogService.open(MultipleaddressComponent, {
      data: data,
      header: 'Select Address',
      width: '60%',
      height: '80%',
      closeOnEscape: false
    });
    ref.onClose.subscribe((am: any) => {
      if (am != undefined) {
        
        this.ba.businessAddressLine1 = am.addressLine1;
        this.ba.businessAddressLine2 = am.addressLine2;

        this.ba.businessStateProvCode = am.state;
        this.ba.businessCityName = am.city;

        this.ba.businessPostalCode = am.pincode;
        this.getLocationByPincode(this.ba.businessPostalCode, 'business', true);
      }
    });
  }

  msgToastInfo(msg) {
    this.messageService.add({ severity: 'info', summary: 'Member Onboard', detail: msg });
  }

  onChangeMethod(i) {
    this.proof[i] = 0;
  }

  onBlurMethod(type, index) {
    this.proof[index] = 0;
    if (this.bdForm.get('Lic_' + index).value) {
      if (type == "GST REGISTRATION" && this.bdForm.get('Lic_' + index).value.length == 15) {
        this.nms.validateGST(this.bdForm.get('Lic_' + index).value).subscribe((res: any) => {
          if (res.code == "SUCCESS") {
           // if (res.response.statusCode == "VALID" && res.response.status == "ACTIVE") {
            //  this.proof[index] = "VALID";
           // } else if (res.response.status == "PROVISIONAL" || res.response.status == "CANCELLED") {
          //    this.proof[index] = "INVALID";
          //  } else {
              this.proof[index] = res.response.statusCode;
              this.licenseVerify['GST'] = res.response.statusCode;
            this.populateLicenceDetails(res, index, type);
          } else {
            this.licenseVerify['GST'] = "RETRY_ERROR";;
            this.validateFailed = true;
            this.proof[index] = "Failed";
            this.hardStopLicenseType[type] = true;
          }
        }, err => {
          this.licenseVerify['GST'] = "RETRY_ERROR";;
          this.validateFailed = true;
          this.proof[index] = "Failed";
          this.hardStopLicenseType[type] = true;
        });
      } else if (type == "UDYOG AADHAAR" && this.bdForm.get('Lic_' + index).value.length == 12) {
        this.nms.validateUAN(this.bdForm.get('Lic_' + index).value).subscribe((res: any) => {
          if (res.code == "SUCCESS") {
            if (res.response.statusCode == "VALID" && res.response.status == "ACTIVE") {
              this.proof[index] = "VALID";
            } else if (res.response.status == "PROVISIONAL" || res.response.status == "CANCELLED") {
              this.proof[index] = "INVALID";
            } else {
              this.proof[index] = res.response.statusCode;
            }
            this.populateLicenceDetails(res, index, type);
          } else {
            this.validateFailed = true;
            this.proof[index] = "Failed";
            this.hardStopLicenseType[type] = true;
          }
        }, err => {
          this.validateFailed = true;
		  this.msgToastInfo("UAN Portal is down, Please manually enter or try later.");
          this.proof[index] = "Failed";
          this.hardStopLicenseType[type] = true;
        });
      }
    }
  }

  retryValidation() {
    for (var i = 0; i < this.bd.businessLicenseParamsList.length; i++) {
      if (this.bd.businessLicenseParamsList[i].name == "GST REGISTRATION" || this.bd.businessLicenseParamsList[i].name == "UDYOG AADHAAR") {
        this.populateLicenceDetails(this.bd.businessLicenseParamsList[i].name, i, this.bd.businessLicenseParamsList[i].name);
      }
    }
  }

  mandatoryAlert(header) {
    this.msgToast(header, 'Please fill all mandatory fields');
  }

  saveBD() {
    if (this.hardStopLicenseType["GST REGISTRATION"] || this.hardStopLicenseType["UDYOG AADHAAR"]) {
      this.hardStop = true;
    } else {
      this.hardStop = false;
    }

    if (this.bdForm.valid && !this.hardStop && !this.validateFailed && this.bd.businessName.length <= 50) {
      
      for (let doc of this.bd.businessLicenseParamsList) {
        if ((!doc.licenseNumber || doc.licenseNumber == "") || (!doc.expirationDate || doc.expirationDate == "") || (!doc.stateProvCode || doc.stateProvCode == "")) {
          this.bdFormValid = false;
          this.mandatoryAlert('Business Details');
          return;
        }
        if (this.uploadedFiles.businessLicenseParamsList) {
          for (let list of this.uploadedFiles.businessLicenseParamsList) {
            if (!list.ustatus) {
              this.bdFormValid = false;
              this.mandatoryAlert('Business Details');
              return;
            }
            if (list.documentType == doc.licenseType) {
              doc.documentId = list.documentId;
            }
            doc.thirdPartyCheck  = this.licenseVerify[doc.licenseType] ? this.licenseVerify[doc.licenseType] : doc.thirdPartyCheck ? doc.thirdPartyCheck : null;
          }
        } else {
          this.bdFormValid = false;
          this.mandatoryAlert('Business Details');
          return;
        }
      }
      if (this.bd.ownerNameNotVisible) {
        if (!this.uploadedFiles.authorizationDocument || !this.uploadedFiles.authorizationDocument[0].ustatus) {
          this.bdFormValid = false;
          return;
        }
        this.bd.authorizationDocument = this.uploadedFiles.authorizationDocument[0];
      } else {
        this.bd.authorizationDocument = {};
      }

      if (this.isDeclToUploaded || this.isSmallOffice) {
        // if (!this.uploadedFiles.supportingDocuments || this.uploadedFiles.supportingDocuments.length == 0
        //   || !this.uploadedFiles.supportingDocuments[0].ustatus) {
        //   this.bdFormValid = false;
        //   return;
        // }
        // this.bd.supportingDocuments = this.uploadedFiles.supportingDocuments;
        // if(this.BDverified==false){
        //   this.bdFormValid = false;
        //     return;
        // }
      } else {
        this.bd.supportingDocuments = [];
      }
      this.sbSpinner = true;
      this.nms.saveBD(this.bd).subscribe((res: any) => {
        this.sbSpinner = true; // show spinner
        if (res.code == "SUCCESS") {
          if (res.response.businessMembershipExist) {
            const ref = this.dialogService.open(DuplicateLicenseComponent, {
              data: res.response.duplicateMembership,
              header: 'Business License Already Exists',
              width: '50%',
              height: '80%',
              closeOnEscape: false,
              styleClass: 'DuplicateLicenseModal'
            });
            ref.onClose.subscribe((ignore) => {
              if (ignore){
                this.loadBusinessAddressView();
                this.msgToastInfo("Business License Already Exists, QC can be processed for this membership only by Store Admin.")
              }
            });
          } else if (res.response.isOCRValidated) {
            this.showOCR(res.response);
          } else {
            this.BDflag = false;
            this.index = 1;
            if (this.ba.businessCityName != null) {
              this.changeCity('business', this.ba.businessCityName);
            }
            if (this.ba.mailingCityName != null) {
              this.changeCity('mailing', this.ba.mailingCityName);
            }
          }
        }
        this.sbSpinner = false; // hide spinner
      }, err => {
        this.sbSpinner = false; // hide spinner
        console.error('ERROR', err);
      });
    } else {
      if (this.hardStop) {
        this.confirmationService.confirm({
          message: "Invalid license number entered",
          acceptLabel: 'Ok',
          rejectVisible: false
        });
      } else if (this.validateFailed) {
        this.confirmationService.confirm({
          message: "License number validation failed",
          acceptLabel: 'Ignore',
          rejectLabel: 'Retry',
          accept: () => {
            this.validateFailed = false;
            this.saveBD();
          },
          reject: () => {
            this.retryValidation();
          }
        });
      } else {
        this.msgToast('Business Details', 'Please fill all mandatory fields');
      }
      this.bdFormValid = false;
      this.sbSpinner = false;
    }
  }

  loadBusinessAddressView() {
    this.BDflag = false;
    this.index = 1;
    if (this.ba.businessPostalCode != null) {
      this.getCountyByPincode(this.ba.businessPostalCode, 'business');
    }
    if (this.ba.mailingPostalCode != null) {
      this.getCountyByPincode(this.ba.mailingPostalCode, 'mailing');
    }
  }

  showOCR(response) {
    let popText: string;
            popText = '<div class="ocrPop"><div class="row"><div class="col-4"><h6>Document</h6></div><div class="col-4"><h6>Fields</h6></div><div class="col-4"><h6>Status</h6></div></div>';
            for (let list of response.memberBusinessLicense) {
              if (list.isLicenseNoOCRScreen != null || list.isBusinessNameOCRScreen != null || list.isDocumentNameOCRScreen != null) {
                if (list.isLicenseNoOCRScreen == "false" || list.isBusinessNameOCRScreen == "false" || list.isDocumentNameOCRScreen == "false") {
                  let doc = "Match";
                  let bn = "Match";
                  let lic = "Match";
                  if (list.isLicenseNoOCRScreen == "false") { lic = 'Mismatch' }
                  if (list.isBusinessNameOCRScreen == "false") { bn = 'Mismatch' }
                  if (list.isDocumentNameOCRScreen == "false") { doc = 'Mismatch' }
                  popText = popText + '<div class="row"><div class="col-4">' + list.licenseType + '</div><div class="col-4"><div class="' + doc + '">Document</div><div class="' + bn + '">Business Name</div><div class="' + lic + '">License No</div></div>';
                  popText = popText + '<div class="col-4"><div class="' + doc + '">' + doc + '</div><div class="' + bn + '">' + bn + '</div><div class="' + lic + '">' + lic + '</div></div></div>';
                }
              }
            }
            popText = popText + '</div>';
            this.confirmationService.confirm({
              message: popText,
              acceptLabel: 'Ignore',
              rejectLabel: 'Edit',
              accept: () => {
                this.BDflag = false;
                this.index = 1;
              }
            });

  }


  saveBA(stepper: MatStepper) {
    if (this.babForm.valid && (this.bamForm.valid || this.bamForm.value.mailsameasbusiness)) {
      this.adProgressBar = true; // show spinner
     
      this.nms.saveBA(this.ba).subscribe((res: any) => {
        if (res.code === "SUCCESS") {
          this.adProgressBar = false; // hide spinner
          this.pm.addressLine1 = this.ba.businessAddressLine1;
          this.pm.addressLine2 = this.ba.businessAddressLine2;
          this.pm.stateProvCode = this.ba.businessStateProvCode;
          this.pm.cityName = this.ba.businessCityName;
          this.pm.postalCode = this.ba.businessPostalCode;
          this.pm.countyName = this.ba.businessCountyName;


          this.pmStateList = [];
          this.pmStateList.push(this.pm.stateProvCode);
          this.pmCityList = [];
          this.pmCityList.push(this.pm.cityName);

          this.pmCountyList = [];
          this.pmCountyList = this.baCountyList;


          stepper.selected.completed = true;
          stepper.next();
        }
      }, err => {
        this.adProgressBar = false; // hide spinner
        console.error('ERROR', err);
      });
    } else {
      if (!this.babForm.valid) {
        this.babFormValid = false;
      }
      if (!this.bamForm.valid && !this.bamForm.value.mailsameasbusiness) {
        this.bamFormValid = false;
      }
      if (!this.bamFormValid) {
        this.mandatoryAlert('Business Address');
      }
    }
  }

  newAddon() {
    if (this.pmForm.valid && this.PMverified) {
      this.pm.cardHolderNbr = 10;
      if (this.uploadedFiles.cardHolderDocuments) {
        for (let list of this.uploadedFiles.cardHolderDocuments) {
          if (!list.ustatus) {
            this.pmFormValid = false;
            return;
          }
        }
      } else {
        this.pmFormValid = false;
        return;
      }
      if (this.pm.isBusinessOwner) {
        if (this.uploadedFiles.cardHolderDocuments.length < 3) {
          this.pmFormValid = false;
          return;
        }
      }
      this.adonSpinner = true; // show spinner
      this.savePM('addon');
    } else {
      if (this.pmForm.get('status') && this.pmForm.get('status').value == "D") {
        if (this.pmForm.get('firstName').valid && this.pmForm.get('lastName').valid && this.pmForm.get('mobile').valid) {
          this.savePM('addon');
        }
      } else {
        this.adonSpinner = false; // hide spinner
        this.pmFormValid = false;
        if (!this.pmForm.valid) {
          if (this.pmForm.get('mailId').valid) {
            this.msgToast('Primary Member', 'Please fill all mandatory fields');
          } else {
            this.msgToast('Primary Member', 'Invalid Email ID');
          }
        } else {
          this.msgToast('Primary Member', 'Mobile number not verified');
        }
      }
    }
  }

  savePM(process) {
    if (this.uploadedFiles.cardHolderDocuments.length != 0) {
      this.uploadedFiles.cardHolderDocuments.forEach((list, i) => {
        if (list.documentType == "PHOTO") {
          this.pm.cardHolderDocuments[0] = list;
        } else if (list.documentType == "PHOTO PROOF") {
          this.pm.cardHolderDocuments[1] = list;
        } else if (list.documentType == "ASSOCIATED PROOF") {
          this.pm.cardHolderDocuments[2] = list;
        }
        if (!this.pm.isBusinessOwner && list.documentType == "ASSOCIATED PROOF") {
          this.uploadedFiles.cardHolderDocuments.splice(i, 1);
          this.pm.cardHolderDocuments.splice(i, 1);
        }
      });
    }
    this.pm.status = "QC PENDING";
    this.nms.savePM(this.pm).subscribe((res: any) => {
      if (res.code == "SUCCESS") {
        if (process == 'submit') {
          this.nms.savePM(this.pm).subscribe((res: any) => {
            if (res.code == "SUCCESS") {
              let data: any = {};
              data.address = this.ba;          
              data.bd = this.bd;
              data.pm = this.pm
              data.addonList = this.addonList;
              data.maId = this.nms.mlid;
              data.bi = this.bi;
              const ref = this.dialogService.open(MemberPrintComponent, {
                data: data,
                width: '90%',
                height: '90%',
                header: 'Preview Member',
                closeOnEscape: false
              });
              ref.onClose.subscribe(() => {
                var temp = document.getElementById('memberPreview');
                if (temp) {
                  document.body.removeChild(temp);
                }
              });
            }
          }, err => {
            console.error('ERROR', err);
          });
        } else {
          let data: any = {};
          data.populateForm = this.populateForm;
          data.address = this.ba;
          data.count = this.addonList.length + 1;
          data.am = {};
          data.pmPhone = this.pm.phoneNbr;
          data.businessCountyList = this.baCountyList;
          data.addonList = this.addonList;
          const ref = this.dialogService.open(AddonmemberComponent, {
            data: data,
            header: 'Create Add-on',
            width: '95%',
            height: '80%',
            closeOnEscape: false,
          });
          ref.onClose.subscribe((am: any) => {
            if(am){
              let found = 0;
              for (let list of this.addonList) {
                if (list.cardHolderNbr == am.cardHolderNbr) {
                  list = am;
                  found = 1;
                }
              }
              if (found == 0) {
                this.addonList.push(am);
              }
            }
          });
        }
      }
      this.adonSpinner = false; // hide spinner
    }, err => {
      this.adonSpinner = false; // hide spinner
      console.error('ERROR', err);
    });
  }
  editAddon(am) {
    let data: any = {};
    data.populateForm = this.populateForm;
    data.am = am;
    data.pmPhone = this.pm.phoneNbr;
    data.businessCountyList = this.baCountyList;
    data.addonList = this.addonList;
    const ref = this.dialogService.open(AddonmemberComponent, {
      data: data,
      header: 'Edit Add-on',
      width: '95%',
      height: '80%',
      closeOnEscape: false
    });
    ref.onClose.subscribe((am: any) => {
      if (am) {
        for (let list of this.addonList) {
          if (list.cardHolderNbr == am.cardHolderNbr) {
            list = am;
          }
        }
      }
    });
  }

  termAddon() {
    const ref = this.dialogService.open(TermConditionComponent, {
      width: '95%',
      height: '80%',
      closeOnEscape: false,
      dismissableMask: true,
      styleClass: 'termWidth',
    });
    this.termAddonVerified = true;
  }

  declareAddon() {
    const ref = this.dialogService.open(DigitalDeclarationComponent, {
      width: '95%',
      height: '80%',
      closeOnEscape: false,
      dismissableMask: true,
      styleClass: 'termWidth',
    });
    this.declareAddonVerified = true;
  }

  submitMember() {
    if (this.pmForm.valid && this.PMverified) {
      this.pm.cardHolderNbr = 10;
      if (this.uploadedFiles.cardHolderDocuments) {
        for (let list of this.uploadedFiles.cardHolderDocuments) {
          if (!list.ustatus) {
            this.pmFormValid = false;
            return;
          }
        }
      } else {
        this.pmFormValid = false;
        return;
      }
      if (this.pm.isBusinessOwner) {
        if (this.uploadedFiles.cardHolderDocuments.length < 3) {
          this.pmFormValid = false;
          return;
        }
      }
      this.savePM('submit');
    } else {
      this.pmFormValid = false;
      if (!this.pmForm.valid) {
        if (this.pmForm.get('mailId').valid) {
          this.msgToast('Primary Member', 'Please fill all mandatory fields');
        } else {
          this.msgToast('Primary Member', 'Invalid Email ID');
        }
      } else {
        this.msgToast('Primary Member', 'Mobile number not verified');
      }
    }
  }

  msgToast(header, msg) {
    this.messageService.add({ severity: 'error', summary: header, detail: msg });
  }

  updateOTPstatus(event, id) {
    if (id == "BIverified") {
      this.BIverified = event;
      this.PMverified = event;
      this.BIverifiedNo = this.bi.phoneNbr;
      this.PMverifiedNo = this.pm.phoneNbr;
    
    } else {
      this.PMverified = event;
      this.PMverifiedNo = this.pm.phoneNbr;
    }
  }

  updateOTPstatusStepper(event, id, stepper: MatStepper) {
    if (id == "BIverified") {
      this.BIverified = event.status;
      this.PMverified = event.status;
      this.BIverifiedNo = this.bi.phoneNbr;
      this.PMverifiedNo = this.pm.phoneNbr;
      this.basicOTPId = event.otpId;
      if (this.biForm.valid) {
        this.saveInfo(stepper);
      }
    } else if (id == "BDverified") {
      this.BDverified = true;
      this.basicOTPId = event.otpId;
      console.log("BDverified == "+ this.BDverified);
    } else {
      this.PMverified = event.status;
      this.PMverifiedNo = this.pm.phoneNbr;
    }
  }

  changeState(addressType, state) {
    if (addressType === "business") {
      this.baCityList = [];
    } else if (addressType === "mailing") {
      this.maCityList = [];
    } else if (addressType === "primary") {
      this.pmCityList = [];
    }

    this.nms.getCityByState(state).subscribe((res: any) => {
      if (res.code === "SUCCESS") {
        if (addressType === "business") {
          this.baCityList = res.response;
        } else if (addressType === "mailing") {
          this.maCityList = res.response;
        } else if (addressType === "primary") {
          this.pmCityList = res.response;
        }
      }
    });
  }

  changeCity(addressType, cityName) {
    if (addressType === "business") {
      this.baCountyList = [];
    } else if (addressType === "mailing") {
      this.maCountyList = [];
    } else if (addressType === "primary") {
      this.pmCountyList = [];
    }

    this.nms.getCountyListByCity(cityName).subscribe((res: any) => {
      if (res.code === "SUCCESS") {
        if (addressType === "business") {
          this.baCountyList = res.response;
        } else if (addressType === "mailing") {
          this.maCountyList = res.response;
        } else if (addressType === "primary") {
          this.pmCountyList = res.response;
        }
      }
    });
  }


  populateBusinessLocation(res) {
    this.ba.businessStateProvCode = "";
    this.ba.businessCityName = "";
    this.ba.businessCountyName = "";
    this.baStateList = [];
    this.baCityList = [];
    this.baCountyList = [];

    this.baStateDropDisable = true;
    this.baCityDropDisable = true;
    this.baStateList.push(res.stateName);
    this.ba.businessStateProvCode = res.stateName;
    this.baCityList.push(res.cityName);
    this.ba.businessCityName = res.cityName;
    this.baCountyList = res.countyNames;
  }

  populatePrimaryLocation(res) {
    this.pm.stateProvCode = "";
    this.pm.cityName = "";
    this.pm.countyName = "";
    this.pmStateList = [];
    this.pmCityList = [];
    this.pmCountyList = [];

    this.pmStateDropDisable = true;
    this.pmCityDropDisable = true;
    this.pmStateList.push(res.stateName);
    this.pm.stateProvCode = res.stateName;
    this.pmCityList.push(res.cityName);
    this.pm.cityName = res.cityName;
    this.pmCountyList = res.countyNames;

  }


  populateMailingLocation(res) {
    this.ba.mailingStateProvCode = "";
    this.ba.mailingCityName = "";
    this.maStateList = [];
    this.maCityList = [];
    this.maCountyList = [];
    this.ba.mailingCountyName = "";

    this.maStateDropDisable = true;
    this.maCityDropDisable = true;
    this.maStateList.push(res.stateName);
    this.ba.mailingStateProvCode = res.stateName;
    this.maCityList.push(res.cityName);
    this.ba.mailingCityName = res.cityName;
    this.maCountyList = res.countyNames;
  }



  contactInfo() {
    var otpInfo: any = {};
    otpInfo.phoneNbr = this.bi.phoneNbr;
    otpInfo.maMembershipId = this.nms.mlid;
    otpInfo.category = "ONBOARDING_OTP_BP";
    otpInfo.apiType = "ONBOARDING_OTP_SMS";
    otpInfo.email = this.bi.email;
    return otpInfo;
  }

  declarationContactInfo() {
    var otpInfo: any = {};
    otpInfo.phoneNbr = this.bi.phoneNbr;
    otpInfo.maMembershipId = this.nms.mlid;
    otpInfo.category = "DECLARATION_OTP_BP";
    otpInfo.apiType = "DECLARATION_OTP_SMS";
    otpInfo.email = this.bi.email;
    return otpInfo;
  }

  getCountyByPincode(pincode, addressType) {
    if (pincode != undefined && pincode.toString().length == 6) {
      this.nms.getLocationByPincode(pincode).subscribe((res: any) => {

        if (res.code === "SUCCESS") {
          if (addressType === 'business') {
            this.baCountyList = [];
            this.baCountyList = res.response.countyNames;            
          } else if (addressType === 'mailing') {
            this.maCountyList = [];
            this.maCountyList = res.response.countyNames;
          } else {
            this.pmCountyList = [];
            this.pmCountyList = res.response.countyNames;
          }
        } 
      });
    }
  }

  

  getLocationByPincode(pincode, addressType, isDirty) {
    if (!isDirty) {
      return;
    }
    if (pincode != undefined && pincode.toString().length == 6) {
      this.nms.getLocationByPincode(pincode).subscribe((res: any) => {

        if (res.code === "SUCCESS") {
          if (addressType === 'business') {
            this.populateBusinessLocation(res.response);
          } else if (addressType === 'mailing') {
            this.populateMailingLocation(res.response);
          } else {
            this.populatePrimaryLocation(res.response);
          }
        } else {
          this.messageService.add({ severity: 'info', summary: 'Member Onboard', detail: 'Select State and City.' });
          if (addressType === 'business') {
            this.baStateList = [];
            this.baCityList = [];
            this.pmCountyList = [];
            this.baStateDropDisable = false;
            this.baCityDropDisable = false;
            this.ba.businessCityName = "";
            this.ba.businessStateProvCode = "";
            this.ba.businessCountyName = "";
            this.baStateList = this.populateForm.states;
          } else if (addressType === 'mailing') {
            this.maStateList = [];
            this.maCityList = [];
            this.pmCountyList = [];
            this.maStateDropDisable = false;
            this.maCityDropDisable = false;
            this.ba.mailingCityName = "";
            this.ba.mailingStateProvCode = "";
            this.ba.mailingCountyName = "";
            this.maStateList = this.populateForm.states;
          } else {
            this.pmStateList = [];
            this.pmCityList = [];
            this.pmCountyList = [];
            this.pmStateDropDisable = false;
            this.pmCityDropDisable = false;
            this.pm.cityName = "";
            this.pm.stateProvCode = "";
            this.pm.countyName = "";
            this.pmStateList = this.populateForm.states;
          }

        }
      });
    } else {
      if (addressType === 'business') {
        this.ba.businessCityName = "";
        this.ba.businessStateProvCode = "";
        this.ba.businessCountyName = "";
      } else if (addressType === 'mailing') {
        this.ba.mailingCityName = "";
        this.ba.mailingStateProvCode = "";
        this.ba.mailingCountyName = "";
      } else {
        this.pm.cityName = "";
        this.pm.stateProvCode = "";
        this.pm.countyName = "";
      }
    }
  }
}
